import React from 'react';

const Logo = ({ size = 'md', className = '' }) => {
    const sizes = {
        sm: { height: 60 },
        md: { height: 90 },
        lg: { height: 120 },
    };

    const currentSize = sizes[size];

    return (
        <div className={`logo-container ${className}`}>
            <img
                src="/logo.png"
                alt="Mauro Astore - Consulenze Assicurative"
                style={{ height: currentSize.height, width: 'auto' }}
            />
        </div>
    );
};

export default Logo;
